import React from 'react';
import * as PropTypes from 'prop-types';

import { FIELDS_TYPE } from '../../../constants';
import { convertTimeTo24HoursFormat } from '../../common/TimePickerRange/utils';
import getFieldValues from '../utils/getFieldValues';
import Fieldset from '../Fieldset';
import { enhance } from './enhance';

const FieldSetList = props => {
  const {
    employeeId,
    onSave,
    fieldSetList,
    disabled,
    onCancelCallback,
    canEdit,
    editWorkingHoursActions,
  } = props;

  const handleSave = (fields, title) => {
    onSave(getFieldValues(fields), title);
  };

  const handleCustomAction = fields => {
    const workingHoursField = fields.find(
      ({ type }) => type === FIELDS_TYPE.CUSTOM_TIME_PICKER,
    );
    if (workingHoursField) {
      const { value } = workingHoursField;

      const data = {
        workingHours: {
          ...(value[2] &&
            value[0] &&
            value[1] && {
              timeZone: value[2].label,
              startTime: convertTimeTo24HoursFormat(value[0]),
              endTime: convertTimeTo24HoursFormat(value[1]),
            }),
        },
      };
      editWorkingHoursActions({ id: employeeId, ...data });
    }
  };

  return (
    <div styleName="fieldsetList profile-children">
      {fieldSetList.map((item, i) => (
        <Fieldset
          key={`block-${i}`}
          fieldset={item}
          onSave={item.useCustomAction ? handleCustomAction : handleSave}
          disabled={disabled || item.disabled}
          onCancelCallback={onCancelCallback}
          canEdit={canEdit}
        />
      ))}
    </div>
  );
};

FieldSetList.propTypes = {
  fieldSetList: PropTypes.array.isRequired,
  onSave: PropTypes.func,
  disabled: PropTypes.bool,
  onCancelCallback: PropTypes.func,
  canEdit: PropTypes.bool,
  editWorkingHoursActions: PropTypes.func,
  employeeId: PropTypes.number,
};

export default enhance(FieldSetList);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/FieldSetList/index.jsx